import fp from "lodash/fp";
import moment from "moment";

export const mapToEditableRows = (items, columnsTemplate, dateFormat) =>
	fp.map(item => {
		const columns = fp.cloneDeep(columnsTemplate);
		Object.keys(item).forEach(key => {
			const column = columns.find(x => x.name === key);
			if (column) {
				column.value = item[key];

				if (column.type === "date") {
					column.value = moment(new Date(column.value)).format(
						dateFormat,
					);
				}
			}
		});
		return { id: item.id, columns };
	}, items);
